import React, { useState, useEffect } from 'react';
import './PostBox.css';
import {
    IconBolt,
    IconPhoto,
    IconPencil
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { POSTBOX_ROUTES } from '../Projects/FromPostbox/routes';
import { useSelector } from 'react-redux';
import { selectResolvedUserData } from '../../../redux/slices/authSlice';
import UserAvatarInfo from './UserAvatarInfo';
import PostBoxModal from './PostBoxModal';
// PostBoxNoModals.css removed - using main PostBox.css

const PostBox = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [placeholderText, setPlaceholderText] = useState("What's on your mind?");

    // Redux state
    const userData = useSelector(selectResolvedUserData);
    const currentUser = useSelector(state => state.auth.currentUser);
    const navigate = useNavigate();

    // Typing animation effect for the placeholder
    useEffect(() => {
        const texts = [
            "What's on your mind?",
            "Share your thoughts...",
            "Start a conversation...",
            "Create a post..."
        ];
        let currentIndex = 0;

        const interval = setInterval(() => {
            setPlaceholderText(texts[currentIndex]);
            currentIndex = (currentIndex + 1) % texts.length;
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    // Handler to open the modal when clicking on the postbox input or action buttons
    const handleOpenModal = () => {
        if (!currentUser) { toast.info('Please log in to create a post'); return; }
        setModalOpen(true);
    };

    // Handler to close the modal
    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <div className="postbox">
            {/* Main Input Container - Always visible */}
            <div className="postbox__input-container">
                <UserAvatarInfo userData={userData} />
                <input
                    onClick={handleOpenModal}
                    className="postbox__input"
                    placeholder={placeholderText}
                    type="text"
                    readOnly
                    value=""
                />
            </div>

            {/* Action buttons - Always visible */}
            <div className="postbox__action-buttons">
                <button
                    className="postbox__action-button"
                    onClick={(e) => { handleOpenModal(); e.currentTarget.blur(); }}
                >
                    <IconBolt size={20} />
                    Action Tags
                </button>
                <button
                    className="postbox__action-button"
                    onClick={(e) => { handleOpenModal(); e.currentTarget.blur(); }}
                >
                    <IconPhoto size={20} />
                    Images
                </button>
                <button
                    className="postbox__action-button"
                    onClick={(e) => { if (!currentUser) { toast.info('Please log in to start a project'); e.currentTarget.blur(); return; } navigate(POSTBOX_ROUTES.intro); e.currentTarget.blur(); }}
                >
                    <IconPencil size={20} />
                    Start Project
                </button>
            </div>

            {/* Render the detached modal component */}
            <PostBoxModal
                open={modalOpen}
                onClose={handleCloseModal}
                userData={userData}
            />
        </div>
    );
};

export default PostBox; 